import type en from "./en";

const de: typeof en = {
  mediaLibrary: {
    title: "Medienbibliothek",
    searchPlaceholder: "Dateien suchen...",
    allFiles: "Alle Dateien",
    filterAll: "Alle Typen",
    filterImages: "Bilder",
    filterDocuments: "Dokumente",
    filterVideos: "Videos",
    filterAudio: "Audio",
    newFolder: "Neuer Ordner",
    folderName: "Ordnername",
    noFiles: "Keine Dateien gefunden",
    dropOrClick: "Dateien hierher ziehen oder klicken zum Hochladen",
    acceptedFormats: "Bilder, PDF, Video, Audio, Dokumente (max. 10 MB)",
    uploading: "Wird hochgeladen...",
    uploadingProgress: "{current} von {total} wird hochgeladen...",
    selectImage: "Bild auswählen",
    selectFile: "Datei auswählen",
    deleteSelected: "Löschen",
    copyUrl: "URL kopieren",
    copied: "Kopiert!",
    browseMedia: "Medienbibliothek durchsuchen",
    renameFolder: "Ordner umbenennen",
    addSubfolder: "Unterordner hinzufügen",
    subfolderName: "Unterordnername",
    sortNewest: "Neueste zuerst",
    sortOldest: "Älteste zuerst",
    sortNameAsc: "Name A-Z",
    sortNameDesc: "Name Z-A",
    sortSizeAsc: "Kleinste zuerst",
    sortSizeDesc: "Größte zuerst",
    moveSelected: "Verschieben",
    moveToRoot: "Alle Dateien",
    currentFolder: "(aktuell)",
    confirmDelete: "Bestätigen?",
    renameFile: "Umbenennen",
    editFile: "Datei bearbeiten",
    fileName: "Dateiname",
    altText: "Alternativtext",
    altTextPlaceholder: "Bildbeschreibung für Barrierefreiheit",
    saveChanges: "Speichern",
    cancel: "Abbrechen",
    frequentlyUsed: "Häufig verwendet",
    deleteWarningTitle: "Datei löschen",
    deleteWarningMessage:
      "Sind Sie sicher? Diese Aktion kann nicht rückgängig gemacht werden.",
    deleteWarningUsageNote:
      "Die folgenden Dateien werden in Vorlagen verwendet. Das Löschen kann diese Vorlagen beschädigen.",
    deleteAnyway: "Löschen",
    usedInTemplates: "In {count} Vorlage(n) verwendet",
    viewGrid: "Rasteransicht",
    viewList: "Listenansicht",
    showFolders: "Ordner anzeigen",
    hideFolders: "Ordner ausblenden",
    importFromUrl: "Von URL importieren",
    importUrlPlaceholder: "https://example.com/image.jpg",
    import: "Importieren",
    importing: "Wird importiert...",
    importError: "Import von URL fehlgeschlagen",
    conversionLabel: "Groesse",
    conversionOriginal: "Original",
    conversionSmall: "Klein (150px)",
    conversionMedium: "Mittel (600px)",
    conversionLarge: "Gross (1200px)",
    replaceFile: "Datei ersetzen",
    replaceWarningTitle: "Datei ersetzen",
    replaceWarningMessage:
      "Sie sind dabei, diese Datei zu ersetzen. Die Ersatzdatei muss dieselbe Dateierweiterung haben ({extension}).",
    replaceWarningUsageNote:
      "Diese Datei wird in {count} Vorlage(n) verwendet. Das Ersetzen aktualisiert alle Verweise.",
    replaceSelectFile: "Ersatzdatei auswählen",
    replace: "Ersetzen",
    replacing: "Wird ersetzt...",
    replaceError: "Ersetzen der Datei fehlgeschlagen",
    saving: "Wird gespeichert...",
    cropAspectRatio: "Seitenverhältnis",
    cropFree: "Frei",
    cropSquare: "1:1",
    cropLandscape43: "4:3",
    cropLandscape169: "16:9",
    cropOriginal: "Original",
    cropMaxWidth: "Max. Breite",
    cropMaxHeight: "Max. Höhe",
    cropOutputSize: "Ausgabegröße",
    cropPixels: "px",
    cropOptional: "(optional)",
    storageTooltip: "{used} von {total} verwendet ({remaining} verfügbar)",
  },
};

export default de;
